module.exports = __webpack_public_path__ + "static/media/home_dark.0b62adf1.svg";